module.exports = __webpack_public_path__ + "static/media/qubitsp-banner.0c9adb70.webp";